/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-07 09:31:42
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-08 10:21:44
 */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api, sendAsync } from "../../app/applicationSlice";
import { RootState, RootThunk, RootThunkApi } from "../../app/store";
import {
  InventoryChangeParams,
  InventoryChangePage,
  InventoryChangeDetail,
  InventoryMergeParams,
  InventoryMergeList,
} from "../../services/InventChange";

export const initialState = {
  ChangeData: [],
  ChangeTotal: 0,
  Current: 1,
  ChangeDetail: [],
  ChangeSelectId: 0,
  ChangeMergeList: [],
  TotalData: {},
};

export const InventoryChangSlice = createSlice({
  name: "InventoryChange",
  initialState,
  reducers: {
    setChangeData(state, action) {
      state.ChangeData = action.payload;
    },
    setChangeCurrent(state, action) {
      state.Current = action.payload;
    },
    setChangeTotal(state, action) {
      state.ChangeTotal = action.payload;
    },
    setChangeDetail(state, action) {
      state.ChangeDetail = action.payload;
    },
    setChangeSelectId(state, action) {
      state.ChangeSelectId = action.payload;
    },
    setChangeMergeList(state, action) {
      state.ChangeMergeList = action.payload;
    },
    setTotalData(state, action) {
      state.TotalData = action.payload;
    },
  },
});

export const {
  setChangeCurrent,
  setChangeData,
  setChangeMergeList,
  setChangeDetail,
  setChangeSelectId,
  setChangeTotal,
  setTotalData,
} = InventoryChangSlice.actions;

export function getInventoryChangepage(
  params: InventoryChangeParams
): RootThunk {
  return api(InventoryChangePage(params), (data: any, dispatch) => {
    dispatch(setChangeData(data.outInvItemPages.records));
    dispatch(setChangeTotal(data.outInvItemPages.total));
    dispatch(
      setTotalData({
        id: (data.outInvItemPages.current - 1) * data.outInvItemPages.size,
        totalProfitPrice: data.totalProfitPrice,
        totalRetailPrice: data.totalRetailPrice,
        totalSplitRetailPrice: data.totalSplitRetailPrice,
        totalSplitUnitPrice: data.totalSplitUnitPrice,
        totalUnitPrice: data.totalUnitPrice,
      })
    );
  });
}

export const getInventoryChangePageAsync = createAsyncThunk<
  void,
  InventoryChangeParams,
  RootThunkApi<void>
>("InventoryChange/detail", async (params, api) => {
  return sendAsync(InventoryChangePage(params), api);
});

export function getInventoryDetail(id: number): RootThunk {
  return api(InventoryChangeDetail(id), (data: any, dispatch) => {
    dispatch(setChangeDetail(data));
  });
}

export function getInventMergeList(params: InventoryMergeParams): RootThunk {
  return api(InventoryMergeList(params), (data: any, dispatch) => {
    dispatch(setChangeMergeList(data.records));
    dispatch(setChangeTotal(data.total));
  });
}

export const selectChangeData = (state: RootState) => {
  const data = state.InventoryChang.ChangeData;
  if (data.length === 0) {
    return data;
  } else {
    return [...data, state.InventoryChang.TotalData];
  }
};

export const selectChangeTotal = (state: RootState) =>
  state.InventoryChang.ChangeTotal;

export const selectChangeCurrent = (state: RootState) =>
  state.InventoryChang.Current;

export const selectChangeDetail = (state: RootState) =>
  state.InventoryChang.ChangeDetail;

export const selectChangeId = (state: RootState) =>
  state.InventoryChang.ChangeSelectId;

export const selectChangeMergeList = (state: RootState) =>
  state.InventoryChang.ChangeMergeList;

export const selectTotalData = (state: RootState) =>
  state.InventoryChang.TotalData;

export default InventoryChangSlice.reducer;
